import { Component, Input, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { IAlert } from 'src/app/core/dto';
import { AmsDateTimePipe } from 'src/app/main/shared/pipes/dates.pipe';
import { QuickPanelService } from '../quick-panel.service';

/**
 * A `TruckLate` or `OrderLate` alert. The title opens the Trucks page with the truck's card expanded;
 * an order alert also links to the order. See `specs/truck-schedule.md`.
 */
@Component({
  selector: 'app-alert-truck-late',
  templateUrl: './alert-truck-late.component.html',
  styleUrls: ['./alert-truck-late.component.scss'],
  imports: [FlexLayoutModule, MatTooltipModule, RouterLink, TranslateModule, AmsDateTimePipe],
})
export class AlertTruckLateComponent {
  @Input() alert: IAlert = {} as IAlert;
  private router = inject(Router);
  private quickPanelService = inject(QuickPanelService);

  /** The order's OrdId, from `JobDetail/{ordId}`; null for a truck alert. */
  get ordId(): string | null {
    const [type, id] = (this.alert.referenceDocumentId ?? '').split('/');
    return type === 'JobDetail' && id ? id : null;
  }

  openTruck() {
    if (this.alert.sref) {
      this.router.navigateByUrl(this.alert.sref);
      this.close();
    }
  }

  close() {
    this.quickPanelService.onSetOpen(false);
  }
}
